import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useRecoilValue } from "recoil";

import { TLoadoutsQuery } from "MVVM/Views/CreateMontage/@types";
import {
  LOADOUT_QUERY,
  ME_QUERY,
  QUICK_EDIT_GET_MOMENT,
} from "MVVM/GraphQL/quickEdit";
import { MOMENT_CREATE_CLIP } from "MVVM/GraphQL/mutations/momentRequestClip";
import { IQuickEditMoment } from "./@types";
import { ActiveCampaign } from "MVVM/State/campaign";
import { useMemo } from "react";
import { CLIP_GAME_MAP } from "MVVM/Utilities/Maps";
import { MOMENT_CREATE_MONTAGE } from "MVVM/GraphQL/mutations/momentsCreateMontage";
import { MY_BALANCE } from "MVVM/GraphQL/montage";

export const QuickEditViewModel = (
  momentId: string,
  skipExtraQueries?: boolean,
) => {
  const activeCampaign = useRecoilValue(ActiveCampaign);

  const { data: momentData } = useQuery<{ moment: IQuickEditMoment }>(
    QUICK_EDIT_GET_MOMENT,
    {
      variables: { id: momentId },
      skip: !momentId || skipExtraQueries,
    },
  );

  const gameId = Number(
    CLIP_GAME_MAP[momentData?.moment.game as keyof typeof CLIP_GAME_MAP],
  );

  const { data: loadoutsData } = useQuery<TLoadoutsQuery>(LOADOUT_QUERY, {
    variables: {
      game: gameId,
      type: "quick_edit",
      skip: skipExtraQueries,
    },
    skip: !gameId,
  });

  const { data: viewerData } = useQuery<{
    me: {
      mediaUploadUrl: {
        fields: {
          name: string;
          value: string;
        }[];
        key: string;
        url: string;
      };
    };
  }>(ME_QUERY, {
    fetchPolicy: "network-only",
  });

  const [momentCreateClip] = useMutation(MOMENT_CREATE_CLIP, {
    onError: (err: any) => {
      console.log(`momentCreateClip error! ${err.message}`);
    },
  });

  const [momentCreateMontage] = useMutation(MOMENT_CREATE_MONTAGE, {
    onError: (err: any) => {
      console.log(`momentCreateMontage error! ${err.message}`);
    },
  });

  const [getBalance] = useLazyQuery(MY_BALANCE, {
    fetchPolicy: "network-only",
    onError: (err: any) => {
      console.log(`balanceError error! ${err.message}`);
    },
  });

  const campaignAlert = useMemo(() => {
    const matchPlayedAt = momentData?.moment?.match?.matchPlayedAt;
    let displayAlert = false;
    let dayAgeAllowed = 0;

    if (matchPlayedAt && activeCampaign?.matchDocumentTtlHours) {
      dayAgeAllowed = activeCampaign?.matchDocumentTtlHours / 24;
      const cutoff = new Date(
        Date.now() - activeCampaign?.matchDocumentTtlHours * 60 * 60 * 1000,
      );
      displayAlert = new Date(matchPlayedAt) < cutoff;
    }
    if (!displayAlert) return null;

    return `This moment is older than ${dayAgeAllowed} day${
      dayAgeAllowed > 1 ? "s" : ""
    } and is not eligible for the ${activeCampaign?.campaign} competition. Your score on the leaderboard wiill not change as a result. `;
  }, [
    activeCampaign?.matchDocumentTtlHours,
    momentData?.moment?.match?.matchPlayedAt,
    activeCampaign?.campaign,
  ]);

  const loadouts = loadoutsData?.loadouts;
  const moment = momentData?.moment;
  const mediaUploadUrl = viewerData?.me.mediaUploadUrl;

  return {
    loadouts,
    moment,
    momentCreateClip,
    momentCreateMontage,
    getBalance,
    mediaUploadUrl,
    campaignAlert,
  };
};
